//angular imports
import { ChangeDetectionStrategy, Component, OnDestroy, signal, WritableSignal } from '@angular/core';

//local imports
import { CatalogConstants, RoomContentModel } from '@app/catalog';
import { BreadcrumbItemToggleMessage, IBreadcrumbItemModel, Messenger, PresenterType } from '@app/shared';
import { Subject } from 'rxjs';



@PresenterType({
  model: RoomContentModel,
  key: 'tileTop'
})
@Component({
  selector: 'room-content-carousel-item',
  templateUrl: './room-content-carousel-item.component.html',
  styleUrl: './room-content-carousel-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RoomContentCarouselItemComponent implements OnDestroy {
  public data: WritableSignal<RoomContentModel> = signal<RoomContentModel>(undefined);

  private readonly destroying$ = new Subject<void>();


  constructor(private messenger: Messenger)
  {}

  public addToBreadCrumb(item: IBreadcrumbItemModel) {
    if(!this.data().shouldAddBreadcrumb()) {
      return;
    }
    this.messenger.send(new BreadcrumbItemToggleMessage(item, CatalogConstants.CATALOG));
  }

  ngOnDestroy() {
    this.destroying$.next(undefined);
    this.destroying$.complete();
  }
}
